module.exports = __webpack_public_path__ + "static/media/logo192.3a9e1fd4.png";